import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { ACCENT } from './DashboardLayout';

export function ArrowIcon() {
  return (
    <Box component="svg" viewBox="0 0 18 18" sx={{ width: 18, height: 18, flexShrink: 0, mt: 0.5, transition: 'transform 0.15s ease' }} aria-hidden="true">
      <path d="M4 9H14M14 9L9.5 4.5M14 9L9.5 13.5" stroke="#8A93A0" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </Box>
  );
}

export function SearchIcon({ color = ACCENT }) {
  return (
    <Box component="svg" viewBox="0 0 20 20" sx={{ width: 20, height: 20 }} aria-hidden="true">
      <circle cx="8.5" cy="8.5" r="6" stroke={color} strokeWidth="1.6" fill="none" />
      <path d="M13.5 13.5L18 18" stroke={color} strokeWidth="1.6" strokeLinecap="round" fill="none" />
    </Box>
  );
}

export function BookmarkIcon({ color = '#16324F' }) {
  return (
    <Box component="svg" viewBox="0 0 18 20" sx={{ width: 18, height: 20 }} aria-hidden="true">
      <path d="M2 1.5H16V18.5L9 14.5L2 18.5V1.5Z" stroke={color} strokeWidth="1.6" strokeLinejoin="round" fill="none" />
    </Box>
  );
}

// icon: a rendered <Icon /> element. iconBg: the tint behind it. to: internal route (uses
// react-router Link so it's a real <a> under the hood, not a div with an onClick).
export default function DashboardActionCard({ icon, iconBg, title, description, to }) {
  return (
    <Box
      component={RouterLink}
      to={to}
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 2.5,
        p: 3.5,
        background: '#FFFFFF',
        border: '1px solid #E2E5EA',
        borderRadius: '12px',
        textDecoration: 'none',
        cursor: 'pointer',
        transition: 'border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease',
        '&:hover': {
          borderColor: ACCENT,
          boxShadow: '0 8px 24px rgba(15, 36, 56, 0.08)',
          transform: 'translateY(-2px)',
        },
        '&:hover .cta-arrow': { transform: 'translateX(4px)' },
      }}
    >
      <Box sx={{ flexShrink: 0, width: 44, height: 44, borderRadius: '10px', background: iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {icon}
      </Box>
      <Box sx={{ flexGrow: 1 }}>
        <Typography sx={{ fontSize: 16, fontWeight: 600, color: '#1B2430' }}>{title}</Typography>
        <Typography sx={{ fontSize: 13.5, color: '#5B6472', mt: 0.5, lineHeight: 1.5 }}>{description}</Typography>
      </Box>
      <Box className="cta-arrow"><ArrowIcon /></Box>
    </Box>
  );
}
